<template>
    <Editor
        icon="mdi-check"
        testo-list="Ordinativi da eseguire"
        url="/audit/ordinativo/"
        :args="{stato: 'pianificato'}"
        :fields="fields"
        :filters="filters"
        checkbox
        no-insert
        no-update
        no-delete
        ref="editor"
    >

        <template #item.data_pianificazione="{ item }">
            <LocalDate time :date="item.data_pianificazione"></LocalDate>
        </template>
        <template #item.stato="{item}">
            <OrdinativoStato :stato="item.stato"></OrdinativoStato>
        </template>
        <template #item.stato_requisiti="{item}">
            {{ item.stato_requisiti.eseguiti }} / {{ item.stato_requisiti.totali }}
        </template>
        <template #actions="{item}">
            <template>
                <Confirm message="Conferma la compilazione?" :item="item" @confirm="conferma">
                    <template #activator="{on, attrs}">
                        <v-btn v-on="on" v-bind="attrs" small color="success" class="mr-2">Conferma</v-btn>
                    </template>
                </Confirm>

            </template>
            <router-link :to="{name: 'ordinativo_checklist', params: {id: item.id}}">
                <v-btn small color="primary">
                    <v-icon small class="mr-2">mdi-check-circle-outline</v-icon>
                    Compila
                </v-btn>
            </router-link>
        </template>
    </Editor>
</template>

<script>
import Editor from "@/components/Editor";
import LocalDate from "@/components/LocalDate";
import OrdinativoStato from "@/components/OrdinativoStato";
import Confirm from "@/components/Confirm";

export default {
    data: () => ({
        fields: [
            {text: 'Convenzione', value: 's_convenzione.nome'},
            {text: 'Ordine', value: 'ordine'},
            {text: 'Lotto', value: 'codice_lotto'},
            {text: 'Data', value: 'data_pianificazione'},
            {text: 'Stato', value: 'stato'},
            {text: 'Requisiti', value: 'stato_requisiti'},
            {text: 'Ispettore', value: 's_ispettore.full_name'},
        ],
        valida: {
            rapporto: null,
            data: null,
        },
        items: [],
        rapporto: null,
    }),
    computed: {
        filters() {
            return [
                {field: 'convenzione', label: 'Convenzione', type: 'ajax', url: '/backend/autocomplete/convenzione'},
                {
                    field: 'ispettore',
                    label: 'Ispettore',
                    type: 'ajax',
                    url: '/backend/autocomplete/userprofile',
                    filter: {ruoli: 'amministratore,ispettore'}
                },
                {field: 'ordine', label: 'Ordine'},
            ]
        },
    },

    methods: {
        async conferma(item) {
            const url = `/audit/ordinativo/${item.id}/conferma/`;
            await this.$http.post(url);
            this.$refs.editor.refresh();
        },
        async valida_rapporto(item) {
            const url = `/audit/ordinativo/${item.id}/valida_rapporto/`;
            await this.$http.postForm(url, {...this.valida});
            this.valida.rapporto = null;
            this.valida.data = null;
            this.$refs.editor.refresh();
        },
        download_rapporto(item) {
            this.$http.downloadFile(`/audit/ordinativo/${item.id}/download_rapporto/`);
        },
    },
    components: {
        Editor,
        LocalDate,
        OrdinativoStato,
        Confirm,
    },
}
</script>